/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationMemberSelect_MemberOptionsQueryVariables = Types.Exact<{
  sorting: Array<Types.OrganisationMembershipsSorting>;
  filters?: Types.InputMaybe<Types.OrganisationMembershipsFilters>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OrganisationMemberSelect_MemberOptionsQuery = { organisationMemberships: { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, membershipStatus: Types.OrganisationMembershipStatus, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } }> } };

export type OrganisationMemberSelect_SelectedMembersQueryVariables = Types.Exact<{
  sorting: Array<Types.OrganisationMembershipsSorting>;
  selectedMembers: Array<Types.Scalars['ID']['input']>;
  limit: Types.Scalars['Int']['input'];
}>;


export type OrganisationMemberSelect_SelectedMembersQuery = { selectedMembers: { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, membershipStatus: Types.OrganisationMembershipStatus, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } }> } };


export const OrganisationMemberSelect_MemberOptionsDocument = gql`
    query OrganisationMemberSelect_MemberOptions($sorting: [OrganisationMembershipsSorting!]!, $filters: OrganisationMembershipsFilters, $search: String) {
  organisationMemberships(
    offset: 0
    limit: 10
    sorting: $sorting
    filters: $filters
    search: $search
  ) {
    edges {
      node {
        id
        firstname
        familyname
        fullname
        membershipStatus
        avatar {
          ...AttachmentSnapshot
        }
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;

/**
 * __useOrganisationMemberSelect_MemberOptionsQuery__
 *
 * To run a query within a React component, call `useOrganisationMemberSelect_MemberOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMemberSelect_MemberOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationMemberSelect_MemberOptionsQuery({
 *   variables: {
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOrganisationMemberSelect_MemberOptionsQuery(baseOptions: Apollo.QueryHookOptions<OrganisationMemberSelect_MemberOptionsQuery, OrganisationMemberSelect_MemberOptionsQueryVariables> & ({ variables: OrganisationMemberSelect_MemberOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationMemberSelect_MemberOptionsQuery, OrganisationMemberSelect_MemberOptionsQueryVariables>(OrganisationMemberSelect_MemberOptionsDocument, options);
      }
export function useOrganisationMemberSelect_MemberOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationMemberSelect_MemberOptionsQuery, OrganisationMemberSelect_MemberOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationMemberSelect_MemberOptionsQuery, OrganisationMemberSelect_MemberOptionsQueryVariables>(OrganisationMemberSelect_MemberOptionsDocument, options);
        }
export function useOrganisationMemberSelect_MemberOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMemberSelect_MemberOptionsQuery, OrganisationMemberSelect_MemberOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationMemberSelect_MemberOptionsQuery, OrganisationMemberSelect_MemberOptionsQueryVariables>(OrganisationMemberSelect_MemberOptionsDocument, options);
        }
export type OrganisationMemberSelect_MemberOptionsQueryHookResult = ReturnType<typeof useOrganisationMemberSelect_MemberOptionsQuery>;
export type OrganisationMemberSelect_MemberOptionsLazyQueryHookResult = ReturnType<typeof useOrganisationMemberSelect_MemberOptionsLazyQuery>;
export type OrganisationMemberSelect_MemberOptionsSuspenseQueryHookResult = ReturnType<typeof useOrganisationMemberSelect_MemberOptionsSuspenseQuery>;
export type OrganisationMemberSelect_MemberOptionsQueryResult = Apollo.QueryResult<OrganisationMemberSelect_MemberOptionsQuery, OrganisationMemberSelect_MemberOptionsQueryVariables>;
export const OrganisationMemberSelect_SelectedMembersDocument = gql`
    query OrganisationMemberSelect_SelectedMembers($sorting: [OrganisationMembershipsSorting!]!, $selectedMembers: [ID!]!, $limit: Int!) {
  selectedMembers: organisationMemberships(
    offset: 0
    limit: $limit
    sorting: $sorting
    filters: {ids: $selectedMembers}
  ) {
    edges {
      node {
        id
        firstname
        familyname
        fullname
        membershipStatus
        avatar {
          ...AttachmentSnapshot
        }
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;

/**
 * __useOrganisationMemberSelect_SelectedMembersQuery__
 *
 * To run a query within a React component, call `useOrganisationMemberSelect_SelectedMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMemberSelect_SelectedMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationMemberSelect_SelectedMembersQuery({
 *   variables: {
 *      sorting: // value for 'sorting'
 *      selectedMembers: // value for 'selectedMembers'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrganisationMemberSelect_SelectedMembersQuery(baseOptions: Apollo.QueryHookOptions<OrganisationMemberSelect_SelectedMembersQuery, OrganisationMemberSelect_SelectedMembersQueryVariables> & ({ variables: OrganisationMemberSelect_SelectedMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationMemberSelect_SelectedMembersQuery, OrganisationMemberSelect_SelectedMembersQueryVariables>(OrganisationMemberSelect_SelectedMembersDocument, options);
      }
export function useOrganisationMemberSelect_SelectedMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationMemberSelect_SelectedMembersQuery, OrganisationMemberSelect_SelectedMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationMemberSelect_SelectedMembersQuery, OrganisationMemberSelect_SelectedMembersQueryVariables>(OrganisationMemberSelect_SelectedMembersDocument, options);
        }
export function useOrganisationMemberSelect_SelectedMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMemberSelect_SelectedMembersQuery, OrganisationMemberSelect_SelectedMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationMemberSelect_SelectedMembersQuery, OrganisationMemberSelect_SelectedMembersQueryVariables>(OrganisationMemberSelect_SelectedMembersDocument, options);
        }
export type OrganisationMemberSelect_SelectedMembersQueryHookResult = ReturnType<typeof useOrganisationMemberSelect_SelectedMembersQuery>;
export type OrganisationMemberSelect_SelectedMembersLazyQueryHookResult = ReturnType<typeof useOrganisationMemberSelect_SelectedMembersLazyQuery>;
export type OrganisationMemberSelect_SelectedMembersSuspenseQueryHookResult = ReturnType<typeof useOrganisationMemberSelect_SelectedMembersSuspenseQuery>;
export type OrganisationMemberSelect_SelectedMembersQueryResult = Apollo.QueryResult<OrganisationMemberSelect_SelectedMembersQuery, OrganisationMemberSelect_SelectedMembersQueryVariables>;